import React, { useState } from 'react';
//import axios from 'axios';
import api from '../axios'; // Import the centralized Axios instance
//import { useNavigate } from 'react-router-dom';


const Login = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [IsLoggedIn, setIsLoggedIn] = useState(false);

  //const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent form submission refresh
    try {
      const response = await api.post('/api/login', {
        username,
        password,
      });

      // Save tokens to localStorage
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('refresh_token', response.data.refresh_token);
      localStorage.setItem('is_admin', JSON.stringify(response.data.is_admin));

      setIsLoggedIn(true); // Update state

      window.location.href = '/'; // ✅ Redirect to main page

      // Call the parent handler to indicate login success
      //onLoginSuccess(response.data.is_admin);
      //navigate('/dashboard'); // Redirect after login

    //} catch (err) {
    //  setError('Login failed:');
    //  console.error(err);
    //}
    } catch (error) {
      console.error('Login failed:', error.response ? error.response.data : error.message);
      setError('Invalid username or password');
   }
  };

  return (
    <div style={{ maxWidth: '300px', margin: '0 auto', padding: '20px' }}>
      <h2>Login</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleLogin}>
        <div>
          <label>Username:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default Login;
